import { type ReactNode } from 'react';
import { X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { CsvExportButton } from './csv-export-button';

function ClearButton({ onClick }: { onClick: () => void }): ReactNode {
  return (
    <button
      onClick={onClick}
      className="p-1.5 text-text-tertiary hover:text-text-primary"
      title="Limpiar filtros"
    >
      <X size={14} />
    </button>
  );
}

export function CollectorInput({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string | undefined) => void;
}): ReactNode {
  return (
    <Input
      placeholder="Collector..."
      value={value}
      onChange={(e) => onChange(e.target.value || undefined)}
      className="!w-32"
    />
  );
}

export function FilterActions({
  dirty,
  onClear,
}: {
  dirty: boolean;
  onClear: () => void;
}): ReactNode {
  return (
    <>
      {dirty && <ClearButton onClick={onClear} />}
      <div className="ml-auto">
        <CsvExportButton />
      </div>
    </>
  );
}
